import Layout from "@/views/layout/Layout.vue";

const motorRouter = {
  path: "/motor",
  redirect: "noredirect",
  name: "motor",
  component: Layout,
  meta: {
    title: "电机"
  },
  children: [
    {
      path: "/motor/equipmentSituation",
      name: "m_equipmentSituation",
      component: resolve =>
        require(["@/views/motor/MequipmentSituation.vue"], resolve),
      meta: {
        title: "设备概况",
        requireAuth: true
      }
    },
    {
      path: "/motor/equipmentplanList/:code",
      name: "m_equipmentplanList",
      component: resolve =>
        require(["@/views/motor/MequipmentplanList.vue"], resolve),
      meta: {
        title: "计划列表",
        requireAuth: true
      }
    },
    {
      path: "/motor/essentialData",
      name: "m_essentialData",
      component: resolve =>
        require(["@/views/motor/MessentialData.vue"], resolve),
      meta: {
        title: "基础数据",
        requireAuth: true
      }
    },
    {
      path: "/motor/essentialDataDetail",
      name: "m_essentialDataDetail",
      component: resolve =>
        require(["@/views/motor/MessentialDataDetail.vue"], resolve),
      meta: {
        title: "设备详情",
        requireAuth: true
      }
    },
    {
      path: "/motor/alarmAndHandling",
      name: "alarmAndHandling",
      component: resolve =>
        require(["@/views/motor/alarmAndHandling/index.vue"], resolve),
      meta: {
        title: "报警与处理",
        requireAuth: true
      }
    },
    {
      path: "/motor/operatingTime",
      name: "operatingTime",
      component: resolve =>
        require(["@/views/motor/operatingTime.vue"], resolve),
      meta: {
        title: "电机运行时长",
        requireAuth: true
      }
    },
    {
      path: "/motor/statusMonitoring",
      name: "statusMonitoring",
      component: resolve =>
        require(["@/views/motor/statusMonitoring.vue"], resolve),
      meta: {
        title: "电机状态监控",
        requireAuth: true
      }
    },
    {
      path: "/motor/statusMonitoring1",
      name: "statusMonitoring1",
      component: resolve =>
        require(["@/views/motor/statusMonitoring1.vue"], resolve),
      meta: {
        title: "电机状态监控",
        requireAuth: true
      }
    },
    {
      path: "/motor/statusMonitoringDetail",
      name: "statusMonitoringDetail",
      component: resolve =>
        require(["@/views/motor/statusMonitoringDetail.vue"], resolve),
      meta: {
        title: "电机状态监控详情",
        requireAuth: true
      }
    },
    {
      path: "/motor/realTtimeMonitor",
      name: "m_realTtimeMonitor",
      component: resolve =>
        require(["@/views/motor/MrealTimeMonitor.vue"], resolve),
      meta: {
        title: "实时监测",
        requireAuth: true
      }
    },
    {
      path: "/motor/chart",
      name: "m_chart",
      component: resolve => require(["@/views/motor/chart.vue"], resolve),
      meta: {
        title: "监测图表",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartD",
      name: "m_chartD",
      component: resolve => require(["@/views/motor/chartD.vue"], resolve),
      meta: {
        title: "监测图表-电机",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartD2",
      name: "m_chartD2",
      component: resolve => require(["@/views/motor/chartD2.vue"], resolve),
      meta: {
        title: "监测图表-电机2",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartB",
      name: "m_chartB",
      component: resolve => require(["@/views/motor/chartB.vue"], resolve),
      meta: {
        title: "监测图表-变压器",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartB2",
      name: "m_chartB2",
      component: resolve => require(["@/views/motor/chartB2.vue"], resolve),
      meta: {
        title: "监测图表-变压器2",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartT",
      name: "m_chartT",
      component: resolve => require(["@/views/motor/chartT.vue"], resolve),
      meta: {
        title: "监测图表-调节阀",
        requireAuth: true
      }
    },
    {
      path: "/motor/chartT2",
      name: "m_chartT2",
      component: resolve => require(["@/views/motor/chartT2.vue"], resolve),
      meta: {
        title: "监测图表-调节阀2",
        requireAuth: true
      }
    },
    {
      path: "/motor/chart2D",
      name: "m_chart2D",
      component: resolve => require(["@/views/motor/chart2D.vue"], resolve),
      meta: {
        title: "监测图表-二维"
        // requireAuth: true
      }
    },
    {
      path: "/motor/observationMotor",
      name: "m_observationMotor",
      component: resolve =>
        require(["@/views/motor/MobservationMotorNew.vue"], resolve),
      meta: {
        title: "待观察电机",
        requireAuth: true
      }
    },
    {
      path: "/motor/realTtimeMonitorInfo/:code",
      name: "m_realTtimeMonitorInfo",
      component: resolve =>
        require(["@/views/motor/MrealTimeMonitorInfo.vue"], resolve),
      meta: {
        title: "检修列表",
        requireAuth: true
      }
    },
    {
      path: "/motor/realTtimeMonitorEleData",
      name: "m_realTtimeMonitorEleData",
      component: resolve =>
        require(["@/views/motor/MrealTimeMonitorEleData.vue"], resolve),
      meta: {
        title: "电气数据",
        requireAuth: true
      }
    },
    {
      path: "/motor/realTtimeMonitorMecData",
      name: "m_realTtimeMonitorMecData",
      component: resolve =>
        require(["@/views/motor/MrealTimeMonitorMecData.vue"], resolve),
      meta: {
        title: "机械数据",
        requireAuth: true
      }
    },
    {
      path: "/motor/maintainDynamic",
      name: "m_maintainDynamic",
      component: resolve =>
        require(["@/views/motor/MmaintainDynamic.vue"], resolve),
      meta: {
        title: "检维修动态",
        requireAuth: true
      }
    },
    {
      path: "/motor/maintainData",
      name: "m_maintainDynamicData",
      component: resolve =>
        require(["@/views/motor/MmaintainDynamicData.vue"], resolve),
      meta: {
        title: "检维修数据",
        requireAuth: true
      }
    },
    {
      path: "/motor/malfunctionEval",
      name: "m_malfunctionEval",
      component: resolve =>
        require(["@/views/motor/MmalfunctionEval.vue"], resolve),
      meta: {
        title: "故障评价",
        requireAuth: true
      }
    },
    {
      path: "/motor/malfunctionList",
      name: "m_malfunctionList",
      component: resolve =>
        require(["@/views/motor/MmalfunctionList.vue"], resolve),
      meta: {
        title: "故障设备",
        requireAuth: true
      }
    },
    {
      path: "/motor/malfunctionList/:code",
      name: "m_malfunctionList1",
      component: resolve =>
        require(["@/views/motor/MmalfunctionList1.vue"], resolve),
      meta: {
        title: "故障设备",
        requireAuth: true
      }
    },
    {
      path: "/motor/malfunctionList/:deviceId",
      name: "m_malfunctionListDeviceId",
      component: resolve =>
        require(["@/views/motor/MmalfunctionListDeviceId.vue"], resolve),
      meta: {
        title: "故障设备",
        requireAuth: true
      }
    },
    {
      path: "/motor/equipmentStatus",
      name: "m_equipmentStatus",
      component: resolve =>
        require(["@/views/motor/MequipmentStatus.vue"], resolve),
      meta: {
        title: "设备状态",
        requireAuth: true
      }
    },
    {
      path: "/motor/equipmentStatusList/:level",
      name: "m_equipmentStatusList",
      component: resolve =>
        require(["@/views/motor/MequipmentStatusList.vue"], resolve),
      meta: {
        title: "状态列表",
        requireAuth: true
      }
    },
    {
      path: "/motor/eitpm",
      name: "m_itpm",
      component: resolve => require(["@/views/motor/MITPM.vue"], resolve),
      meta: {
        title: "ITPM决策",
        requireAuth: true
      }
    },
    {
      path: '/motor/homeToDynamic',
      name: 'homeToDynamic',
      component: resolve => require(["@/views/motor/homeToDynamic.vue"], resolve),
      meta: {
        title: "检维修动态",
        requireAuth: true
      }
    },
    {
      path: "/motor/alarmProcessing",
      name: "m_alarmProcessing",
      component: resolve =>
        require(["@/views/motor/MalarmProcessingNew.vue"], resolve),
      meta: {
        title: "报警与处理",
        requireAuth: true
      }
    },
    {
      path: "/motor/alarmChart",
      name: "m_alarmChart",
      component: resolve => require(["@/views/motor/MalarmChart.vue"], resolve),
      meta: {
        title: "报警监测图表",
        requireAuth: true
      }
    },
    {
      path: "/motor/modifyRule",
      name: "m_modifyRule",
      component: resolve => require(["@/views/motor/MmodifyRule.vue"], resolve),
      meta: {
        title: "全局规则",
        requireAuth: true
      }
    },
    {
      path: "/motor/tFactorRule",
      name: "m_tFactor",
      component: resolve => require(["@/views/motor/tFactorRule.vue"], resolve),
      meta: {
        title: "全局规则",
        requireAuth: true
      }
    },
    {
      path: "/motor/maintenanceRecords",
      name: "maintenanceRecords",
      component: resolve =>
        require(["@/views/motor/analysis/mrList.vue"], resolve),
      meta: {
        title: "电机检修记录",
        requireAuth: true
      }
    },
    {
      path: "/motor/faultTree",
      name: "faultTree",
      component: resolve =>
        require(["@/views/motor/analysis/faultTree.vue"], resolve),
      meta: {
        title: "故障树分析",
        requireAuth: true
      }
    },
    {
      path: "/motor/fmea",
      name: "fmea",
      component: resolve =>
        require(["@/views/motor/analysis/fmea.vue"], resolve),
      meta: {
        title: "故障模式影响分析",
        requireAuth: true
      }
    },
    {
      path: "/motor/planSchedule",
      name: "m_planSchedule",
      component: resolve =>
        require(["@/views/motor/MplanSchedule.vue"], resolve),
      meta: {
        title: "年度计划",
        requireAuth: true
      }
    }
  ]
};

export default motorRouter;



// WEBPACK FOOTER //
// ./src/router/modules/motor.js